import { render, staticRenderFns } from "./CommunityAdd.vue?vue&type=template&id=8b610820&"
import script from "./CommunityAdd.vue?vue&type=script&lang=js&"
export * from "./CommunityAdd.vue?vue&type=script&lang=js&"
import style0 from "./CommunityAdd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports